<template>

    <div class="container">

        <div class="handle-box-search">


            <el-button type="primary" icon="el-icon-search" @click="searchprizeLists">搜索</el-button>
            <el-button @click="add_show = !add_show">添加</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

        </div>

        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
                  @selection-change="handleSelectionChange">




            <el-table-column prop="prize_name" label="奖项名称">
            </el-table-column>

            <el-table-column prop="prize_num" label="奖品数量">
            </el-table-column>

            <el-table-column prop="live_num" label="剩余数量">
            </el-table-column>


            <el-table-column prop="level" label="奖品位置">
            </el-table-column>

            <el-table-column prop="type.alias" label="类型">
            </el-table-column>

            <el-table-column prop="amount" label="金额">
            </el-table-column>
            <el-table-column prop="coupon_name" label="优惠券">
            </el-table-column>





            <el-table-column label="操作" width="150">
                <template slot-scope="scope">

                    <el-dropdown split-button type="primary"
                                 @click="edit_show = !edit_show; edit_data = scope.row.prize_code; " trigger="click">

                        编辑
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="deleteData(scope.row.prize_code)">删除</el-dropdown-item>
                        </el-dropdown-menu>



                    </el-dropdown>




                </template>
            </el-table-column>



        </el-table>




        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>


        <!-- 添加组件 -->
        <addPrize :isShow="add_show" @onSubmit="prizeLists"></addPrize>


        <!-- 编辑组件 -->
        <editPrize :isShow="edit_show" @onSubmit="prizeLists" :data="edit_data"></editPrize>



    </div>

</template>

<script>
    var _this;
    import addPrize from './addPrize.vue';
    import editPrize from './editPrize.vue';
    export default {
        components: {
            addPrize,
            editPrize,
        },

        data() {
            return {


                add_show: false,
                edit_show: false,
                edit_data: '',



                // 存放表格数据
                tableData: [],

                //翻页数据
                search_data: {
                    page: 1,
                    limit: 10,
                },

                delPrizeSubmit_data: {
                    prize_code_array: []
                },
                delPrizeSubmit_rules: {
                    prize_code_array: {
                        placeholder: '权限模块',
                        rules: {
                            required: false,
                            message: '权限模块代码数组(json)',
                            regulation: 'special',
                            rulesData: 'json_array'
                        }
                    }
                },

                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    },

                },
            };
        },
        created() {
            _this = this;
            _this.prizeLists();
        },

        methods: {
            // 批量删除
            deleteData(code) {


                _this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {

                    confirmButtonText: '确定',

                    cancelButtonText: '取消',

                    type: 'warning',

                }).then(() => {


                    _this.$post(
                        "/prize/deletePrizeSubmit",
                        {
                            prize_code:code
                        }
                    )
                        .then(res => {
                            console.log(res);

                            _this.$message.success('删除成功!');

                            //初始化显示列表
                            _this.prizeLists();

                            return;

                        }).catch((err) => {
                        console.log(err);



                    })



                }).catch(() => {

                    _this.$message.info('已取消删除');

                });

            },




            searchprizeLists() {

                _this.search_data.page = 1;
                _this.prizeLists();

            },
            // 搜索司机日志列表
            prizeLists() {
                _this.$post(
                    "/prize/prizeLists",
                    _this.search_data,
                    _this.search_rules
                )
                    .then(res => {


                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;

                    }).catch((err) => {

                })
            },
            //翻页组件的回调
            pages_function(search_data) {

                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.prizeLists();

            },

            handleSelectionChange(val) {

                var datalist = [];

                for (var i in val) {

                    datalist.push(val[i].prize_code);

                }
                _this.delPrizeSubmit_data.prize_code_array = datalist;
            },
            // 刷新按钮
            refresh() {
                this.$router.go(0);
            },

        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 200px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .el-table__row {
        height: 100px;
    }

    .el-form-item.el-form-item--small {
        width: 100%;
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
    }

    .el-form-item__content span {
        display: inline-block;
        width: 100%;
        word-wrap: break-word;
        white-space: normal;
    }
</style>
